import { render, staticRenderFns } from "./LivestockPanel.vue?vue&type=template&id=3e8e6a89&scoped=true&"
import script from "./LivestockPanel.vue?vue&type=script&lang=js&"
export * from "./LivestockPanel.vue?vue&type=script&lang=js&"
import style0 from "./LivestockPanel.vue?vue&type=style&index=0&id=3e8e6a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e6a89",
  null
  
)

export default component.exports